import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';

/**
 * Checks if the petition should be able to record a video.
 */
export const useDisableVideoCreation = (): boolean => {
	const {
		data: { petition },
	} = usePetitionActionsPageData();

	return !petition.canCreateVideo;
};
